import {
  Card,
  CardContent,
  CardHeader,
  Typography,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  Box
} from '@mui/material';
import { CreditCard, LocationOn, AccountBalance } from '@mui/icons-material';
import { memo } from 'react';

interface PaymentMethodSectionProps {
  value: string;
  onChange: (value: string) => void;
}

const paymentOptions = [
  {
    value: "PAY_ONLINE",
    label: "Payment Online Only",
    description: "Customers must pay online when booking",
    icon: CreditCard,
  },
  {
    value: "PAY_AT_SALON",
    label: "Pay at Venue",
    description: "Customers pay when they arrive at the salon",
    icon: LocationOn,
  },
  {
    value: "BOTH",
    label: "Both Options",
    description: "Allow customers to choose their preferred payment method",
    icon: AccountBalance,
  },
];

const PaymentMethodSectionComponent = ({ value, onChange }: PaymentMethodSectionProps) => {
  return (
    <Card elevation={2}>
      <CardHeader
        avatar={<CreditCard sx={{ color: '#ba2156' }} />}
        title={
          <Typography variant="h6" component="h3">
            Payment Method
          </Typography>
        }
        subheader={
          <Typography variant="body2" color="text.secondary">
            Choose how customers can pay for their salon services
          </Typography>
        }
      />
      <CardContent>
        <FormControl component="fieldset">
          <RadioGroup value={value} onChange={(e) => onChange(e.target.value)}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              {paymentOptions.map((option) => {
                const Icon = option.icon;
                return (
                  <Box
                    key={option.value}
                    sx={{
                      p: 2,
                      border: '1px solid',
                      borderColor: 'grey.300',
                      borderRadius: 2,
                      '&:hover': { bgcolor: 'action.hover' },
                      transition: 'background-color 0.2s'
                    }}
                  >
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                      <FormControlLabel
                        value={option.value}
                        control={
                          <Radio 
                            sx={{ 
                              color: '#ba2156', 
                              '&.Mui-checked': { color: '#ba2156' } 
                            }} 
                          />
                        }
                        label=""
                      />
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flex: 1 }}>
                        <Box 
                          sx={{ 
                            width: 32, 
                            height: 32, 
                            borderRadius: '50%', 
                            bgcolor: 'rgba(186, 33, 86, 0.1)', 
                            display: 'flex', 
                            alignItems: 'center', 
                            justifyContent: 'center' 
                          }}
                        >
                          <Icon sx={{ fontSize: 16, color: '#ba2156' }} />
                        </Box>
                        <Box>
                          <Typography variant="body1">{option.label}</Typography>
                          <Typography variant="body2" color="text.secondary">
                            {option.description}
                          </Typography>
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                );
              })}
            </Box>
          </RadioGroup>
        </FormControl>
      </CardContent>
    </Card>
  );
};

export const PaymentMethodSection = memo(PaymentMethodSectionComponent);